/**
 * Creates an object composed of keys generated from obtaining the value of the source object accessed by the given key.
 * The corresponding value of each key is the source object.
 * @example
 * const exampleArray = [{id: 124, itemName: 'avatar'}, {id: 125, itemName: 'avatar'}]
 * // returns
 *  {
 *      124: {id: 124, itemName: 'avatar'},
 *      125: {id: 125, itemName: 'avatar'},
 *  }
 * _keyBy(exampleArray, 'id')
 */
export function _keyBy<T, K extends keyof T>(
    collection: T[],
    project: K,
): T[K] extends number | string ? Lookup<T> : never;

/**
 * Null | undefined will return an empty lookup
 */
export function _keyBy<T, R>(collection: undefined | null, project: any): Lookup<T>;

/**
 * Override implementation.
 */
export function _keyBy<T, R>(collection: any, project: any): Lookup<T> {
	if (!collection) return {}
	const result: Lookup<T> = {}

	for (const element of collection) {
		const key = element[project]
		result[key] = element
	}
	return result
}
